const updateTitleRemote = ({ data: { title, titleLocales, updatedAt } }) => {
  return {
    editorChapterTitle: title,
    editorChapterTitleIsEdited: true,
    editorChapterTitleLocales: titleLocales,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  };
};

export default updateTitleRemote;
